import React, { useEffect, useState } from 'react';
import { SortCondition } from 'shared/enums';
import { dataForRvdTable, sortingDate } from 'shared/helpers/utils';
import { usePullSort } from 'shared/hooks';
import { Badge, Spin } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import CommonTable from 'features/tables/commonTable';
import { TCommonColumns } from 'shared/types/overtime.types';
import { RvdStatuses } from 'shared/enums/rvd';
import { useLazyGetRvdQuery } from 'app/services/edpApiV1/rvd';
import SearchComponent from 'shared/components/search/rvd-overtime';
import { ISearchData } from 'shared/types/rvd.types';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { useAppSelector } from 'app/store';

const RvdSubstitutionsArchive = () => {
  const [search, setSearch] = useState<ISearchData>({});
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const [sortInfo, trigger] = usePullSort();
  const [getRvds, { data, isFetching, isLoading }] = useLazyGetRvdQuery();
  const navigate = useNavigate();
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const onclickToRow = (id: number) => {
    navigate(`/rvd/update/${id}`);
  };

  useEffect(() => {
    const newData = {};
    Object.keys(search).forEach(key => {
      if (search[key]) {
        newData[key] = search[key];
      }
    });
    getRvds({
      page: currentPage,
      size: currentSize,
      orderDate: sortInfo.value ? sortInfo.value : undefined,
      type: 'otherArchive',
      allAvailableOrganizations,
      ...newData,
    });
  }, [currentPage, currentSize, getRvds, search, sortInfo.value, allAvailableOrganizations]);

  const onSearch = (data: ISearchData) => {
    setSearch({ ...data });
  };

  const columns: TCommonColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Дата',
      dataIndex: 'created',
      key: 'created',
      sortDirections: [SortCondition.ASCEND, SortCondition.DESCEND],
      sorter: true,
      onHeaderCell: _ => ({
        onClick: () => trigger(),
      }),
    },
    {
      title: 'Количество сотрудников',
      dataIndex: 'count',
      key: 'count',
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: status => (
        <span>
          <Badge status={status === RvdStatuses.NOT_LOADED_CPRODUCT ? 'processing' : 'default'} />
          {status}
        </span>
      ),
    },
    {
      title: 'Комментарий',
      dataIndex: 'userComment',
      key: 'userComment',
      render: (userComment: string) => {
        return (
          <div title={userComment} className="rvd-user-comment">
            {userComment}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <SearchComponent onSearch={onSearch} />
      <Spin spinning={isLoading && isFetching}>
        <CommonTable
          dataSource={dataForRvdTable(data?.data ? data.data : [])}
          columns={columns}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          total={data?.pagination.total}
          setCurrentSize={setCurrentSize}
          currentSize={currentSize}
          onclickToRow={(id: number) => onclickToRow(id)}
        />
      </Spin>
    </>
  );
};

export default RvdSubstitutionsArchive;
